import { LoadingButton } from '@mui/lab';
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import config, { API_SERVER } from '../../EnvConfig/env_config';
import { setFocus } from '../Common/Common';
import { AlertBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from './Loader';
import './LoginCSS.css';
import PasswordChecklist from "react-password-checklist";
import { FaEye, FaEyeSlash, FaLock, FaUser } from 'react-icons/fa';

const cookies = new Cookies();
export default function SignIn() {
    const StaticToken = config.secret_key;
    const source = 'web'

    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState({ userCode: '', password: '' });
    let [state, setState] = useState(false);

    const handleLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const data = {
            Token: StaticToken,
            UserCode: user.userCode !== '' ? user.userCode : '',
            Password: user.password,
            Source: source
        }
        post(`${API_SERVER}/api/UserLogin/Login`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                cookies.set('token', res.token);
                cookies.set('loginUserCode', res.loginUserCode);
                cookies.set('userName', res.userName);
                cookies.set('salesPersonCode', res.salesPersonCode);
                cookies.set('warehouseCode', res.warehouseCode);
                cookies.set('warehouseName', res.warehouseName);
                cookies.set('loginType', res.loginType);
                setTimeout(() => {
                    setIsLoading(false);
                    navigate(location.state || '/Dashboard')
                    localStorage.setItem('ID', "0")
                }, 700)
            } else {
                setState(false);
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus);
            }
        })
    };
    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };
    useEffect(() => {
        setFocus("txtUserCode");
        const cookies = new Cookies();
        cookies.remove('token')
        cookies.remove('loginUserCode')
        cookies.remove('userName')
        cookies.remove('CookieConsentByFineshop')
        cookies.remove('csrftoken')
        cookies.remove('salesPersonCode')
        cookies.remove('warehouseCode')
        cookies.remove('warehouseName')
        cookies.remove('loginType')
    }, [])

    return (
        <>
            {/* <div className="container-fluid bg-login" >
                <div className="row  vh-100"  >
                    <div className="col-xl-9 col-md-8 d-flex justify-content-center align-items-center flex-column" style={{ background: 'linear-gradient(45deg, #16625e, #28a892)' }}>
                        <img src="./assets/img/login-bg.svg" style={{ width: '50%' }} alt=''></img>
                        <h2 className="text-white py-4">Welcome Back!</h2>

                    </div>
                    <div className="col-xl-3 col-md-4 px-4 py-5 main-login text-black rounded">
                        <div >
                            <img src="./assets/img/indo-logo.png" className='img1' alt="..." style={{ display: "flex", backgroundColor: 'white',width:"200px" }} />

                        </div>
                        <div className="">
                            <form method='POST' >
                                <h5 className="my-2 mb-4 text-center text-dark"> Login to your account </h5>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">User Code </label>
                                        <input
                                            id="txtUserCode"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            name='userCode'
                                            placeholder='User Code/Mobile No'
                                            maxLength='13'
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') { setFocus("txtPassword") };
                                            }}
                                            value={user.userCode}
                                            onChange={(e) => {
                                                setUser({ ...user, userCode: e.target.value })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">Password</label>
                                        <div className="d-flex " style={{ position: "relative", width: "104%" }}>
                                            <input
                                                id="txtPassword"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleLogin(e)
                                                    };
                                                }}
                                                type={showPassword.password ? 'text' : 'password'}
                                                className="form-control"
                                                autoComplete="off"
                                                placeholder='Password'
                                                maxLength='20'
                                                name='Password'
                                                value={user.password}
                                                onChange={(e) => setUser({ ...user, password: e.target.value })}
                                            />
                                            <span style={{ position: "relative", right: "22px", top: "3px", cursor: "pointer", color: "black" }} onClick={() => handleTogglePassword('password')}>
                                                {showPassword.password ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {user.password !== '' && <>
                                    <PasswordChecklist
                                        rules={["minLength", "number", "lowercase", "capital", "specialChar",]}
                                        minLength={8}
                                        style={{color:"black"} }
                                        value={user.password}
                                        iconSize='10'
                                        messages={{
                                            minLength: "Password has at least 8 caracteres.",
                                            number: "Password has at least a number.",
                                            lowercase: "Password has at least lowercase letter.",
                                            capital: "Password has at least uppercase letter.",
                                            specialChar: "Password has at least a special character.",
                                        }}
                                    />
                                </>}
                                <div className="py-2 loading">
                                    <LoadingButton loading={state} disabled={isLoading} style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleLogin} className=' py-1 w-100' variant="contained"> Login </LoadingButton>
                                    {isLoading && (<Loader text='AUTHENTICATING' size='100px' img_path='./assets/img/giphy.gif' />)}
                                </div>
                                <div className='d-flex justify-content-between login-trouble mb-3' >
                                    <Link to='/forgotPassword' style={{ textDecoration: "underline" }} >Forgot Password?</Link>  
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className='login_main'>
                <div className='dot_shape position-absolute'>
                    <img src="./assets/img/dot.png" alt="shape" />
                </div>
                <div className='india_clip position-absolute'>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        {/* <div className="col-md-6">
                            <div className='fxt-column-wrap justify-content-center'>
                                <div className='lftimg'>
                                    <img src="./assets/img/login-bg.svg" alt="login" />
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-4">
                            <div className="fxt-column-wrap justify-content-center">
                            <div className='form-container '>
                                <div className='text-center mb-5'>
                                     
                                        <img src="./assets/img/shop4alllogo.png" style={{ width: '250px' }} alt="QR Code" />
                                    <h4 className='mt-4 fw-bold'>Login into account</h4>
                                    <p className='text-black-50'>Use your credentials to access your account.</p>
                                </div>
                                <div class="form-group mb-3 position-relative">
                                    <input 
                                        id="txtUserCode"
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        name='userCode'
                                        placeholder='User Code'
                                        maxLength='50'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') { setFocus("txtPassword") };
                                        }}
                                        value={user.userCode}
                                        onChange={(e) => {
                                            setUser({ ...user, userCode: e.target.value })
                                        }}/>
                                    <div className='input_icon'>
                                        <FaUser/>
                                    </div>
                                </div>
                                <div class="form-group mb-3 position-relative">
                                    <input 
                                        id="txtPassword"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleLogin(e)
                                                    };
                                                }}
                                                type={showPassword.password ? 'text' : 'password'}
                                                className="form-control"
                                                autoComplete="off"
                                                placeholder='Password'
                                                maxLength='20'
                                                name='Password'
                                                value={user.password}
                                                onChange={(e) => setUser({ ...user, password: e.target.value })} />
                                                <span style={{ position: "absolute", right: "22px", top: "50%", transform:'translateY(-58%)', cursor: "pointer" }} onClick={() => handleTogglePassword('password')}>
                                                    {showPassword.password ? <FaEyeSlash /> : <FaEye />}
                                                </span>
                                                <div className='input_icon'>
                                                    <FaLock/>
                                                </div>
                                </div>
                                {user.password !== '' && <>
                                    <PasswordChecklist
                                        rules={["minLength", "number", "lowercase", "capital", "specialChar",]}
                                        minLength={8}
                                        style={{color:"black"} }
                                        value={user.password}
                                        iconSize='10'
                                        messages={{
                                            minLength: "Password has at least 8 caracteres.",
                                            number: "Password has at least a number.",
                                            lowercase: "Password has at least lowercase letter.",
                                            capital: "Password has at least uppercase letter.",
                                            specialChar: "Password has at least a special character.",
                                        }}
                                    />
                                </>}
                                <div className='d-flex justify-content-between login-trouble mb-3' >
                                    <small><Link to='/forgotPassword' style={{ textDecoration: "underline" }} >Forgot Password?</Link>  </small>
                                </div>
                                <div className="py-2 loading">
                                    <LoadingButton loading={state} disabled={isLoading} style={{ background: "var(--mycolorFilterCheckText)",borderRadius:'30px' }} loadingPosition='center' onClick={handleLogin} className=' py-2 w-100' variant="contained"> Login </LoadingButton>
                                    {isLoading && (<Loader text='AUTHENTICATING' size='100px' img_path='./assets/img/giphy.gif' />)}
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}





